import { mutationTypes, actionTypes } from '../access-keys'
import defaultStates from './consumption/default-states'
import { map } from '../helpers/mapper'

export default {
  namespaced: true,
  state: defaultStates.forRoot(),
  getters: {},
  mutations: {
    [mutationTypes.consumption.RESET_STATE](state) {
      map(defaultStates.forRoot(), state)
    },
    [mutationTypes.consumption.ACTIVATE_STEP](state, step) {
      if (step > state.stepActiveTo) {
        state.stepActiveTo = step
      }
    },
    [mutationTypes.consumption.UNACTIVATE_STEP](state, step) {
      if (step < state.stepActiveTo) {
        state.stepActiveTo = step
      }
    }
  },
  actions: {
    [actionTypes.consumption.RESET_FORM]({ commit }) {
      commit(mutationTypes.consumption.RESET_STATE)
      commit(mutationTypes.consumption.step1.RESET_STATE_ROOT, null, { root: true })
      commit(mutationTypes.consumption.step2.RESET_STATE_ROOT, null, { root: true })
    }
  },
  modules: {
    step1: {
      namespaced: true,
      state: defaultStates.forStep1(),
      getters: {},
      mutations: {
        [mutationTypes.consumption.step1.RESET_STATE](state) {
          map(defaultStates.forStep1(), state)
        },
        [mutationTypes.consumption.step1.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.consumption.step1.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.consumption.step1.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.consumption.ACTIVATE_STEP_ROOT, 2, { root: true })
        }
      }
    },
    step2: {
      namespaced: true,
      state: defaultStates.forStep2(),
      getters: {},
      mutations: {
        [mutationTypes.consumption.step2.RESET_STATE](state) {
          map(defaultStates.forStep2(), state)
        },
        [mutationTypes.consumption.step2.REGISTER_FORM_DATAS](state, payload) {
          state.formDatas = payload
          state.isValidated = true
        }
      },
      actions: {
        [actionTypes.consumption.step2.COMPLETE_STEP]({ commit, state }, payload) {
          commit(mutationTypes.consumption.step2.REGISTER_FORM_DATAS, payload)
          commit(mutationTypes.root.CLEAR_API_ERRORS, null, { root: true })
          commit(mutationTypes.consumption.ACTIVATE_STEP_ROOT, 3, { root: true })
        }
      }
    }
  }
}
